import { ButtonProps } from '@procore/core-react/dist/_typedoc/Button/Button.types.json';
import * as React from 'react';
export default {
  ButtonProps,
  React
};